export default __webpack_public_path__ + "static/media/C232251.b30c9ed6.jpg";